/**
 * Way2Buy24 – Externe Produktdaten.
 * Lädt Icecat / 1WorldSync / Flix / Loadbee erst, wenn ein Produktdaten-Tab sichtbar wird.
 */
(function () {
  'use strict';

  const slots = ['icecat-produktinfo', 'icecat-tech-specs', 'icecat-downloads', 'icecat-nachhaltigkeit', 'icecat-bilder'];
  const configEl = document.querySelector('[data-product-external-config]');
  const hasSlots = slots.some((id) => document.getElementById(id));
  if (!configEl || !hasSlots) return;

  let config = {};
  try {
    config = JSON.parse(configEl.textContent || '{}');
  } catch (error) {
    return;
  }
  if (config.enabled === false) return;

  const state = { loaded: false, loading: false };

  function escapeHTML(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function safeURL(value) {
    const raw = String(value || '').trim();
    if (!raw) return '';
    try {
      const url = new URL(raw, window.location.origin);
      if (!['http:', 'https:'].includes(url.protocol)) return '';
      return url.href;
    } catch (error) {
      return '';
    }
  }

  function sanitizeMarkup(html) {
    const template = document.createElement('template');
    template.innerHTML = String(html || '');
    template.content.querySelectorAll('script, style, iframe, object, embed, form, input, button').forEach((el) => el.remove());
    template.content.querySelectorAll('*').forEach((el) => {
      Array.from(el.attributes).forEach((attr) => {
        const name = attr.name.toLowerCase();
        const value = attr.value || '';
        if (name.startsWith('on')) el.removeAttribute(attr.name);
        if ((name === 'href' || name === 'src') && !safeURL(value)) el.removeAttribute(attr.name);
      });
    });
    return template.innerHTML;
  }

  function setHTML(id, html) {
    const el = document.getElementById(id);
    if (!el) return;
    el.innerHTML = sanitizeMarkup(html);
  }

  function setText(id, text) {
    const el = document.getElementById(id);
    if (!el) return;
    el.textContent = text;
  }

  function appendScript(src, attrs = {}) {
    const url = safeURL(src);
    if (!url) return null;
    const sc = document.createElement('script');
    sc.async = true;
    sc.src = url;
    Object.entries(attrs).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') sc.setAttribute(key, String(value));
    });
    document.body.appendChild(sc);
    return sc;
  }

  function apiUrl() {
    const ean = String(config.ean || '');
    const vendor = String(config.vendor || '');
    const sku = String(config.sku || '');
    const user = String(config.icecatUser || '');
    const lang = String(config.language || 'DE');
    if (!user) return '';
    if (ean && ean.length >= 8) {
      return `https://live.icecat.biz/api?UserName=${encodeURIComponent(user)}&Language=${encodeURIComponent(lang)}&GTIN=${encodeURIComponent(ean)}`;
    }
    if (!vendor || !sku) return '';
    return `https://live.icecat.biz/api?UserName=${encodeURIComponent(user)}&Language=${encodeURIComponent(lang)}&Brand=${encodeURIComponent(vendor)}&ProductCode=${encodeURIComponent(sku)}`;
  }

  function openLightbox(src) {
    const url = safeURL(src);
    if (!url) return;
    let lb = document.getElementById('icecat-lightbox');
    if (!lb) {
      lb = document.createElement('div');
      lb.id = 'icecat-lightbox';
      lb.innerHTML = '<div class="icecat-lb-backdrop"></div><div class="icecat-lb-inner"><button class="icecat-lb-close" type="button" aria-label="Schließen">&times;</button><img class="icecat-lb-img" src="" alt=""></div>';
      document.body.appendChild(lb);
      const close = () => {
        lb.classList.remove('is-open');
        document.body.style.overflow = '';
      };
      lb.querySelector('.icecat-lb-backdrop')?.addEventListener('click', close);
      lb.querySelector('.icecat-lb-close')?.addEventListener('click', close);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
      });
    }
    const img = lb.querySelector('.icecat-lb-img');
    if (img) img.src = url;
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  window._icecatLb = openLightbox;

  function renderBilder(productData) {
    const imgs = [];
    (productData.Gallery || []).forEach((g) => {
      const full = safeURL(g.Pic || g.Pic500x500 || '');
      const thumb = safeURL(g.Pic500x500 || g.Pic160 || full);
      if (full) imgs.push({ thumb: thumb || full, full, main: g.IsMain === 'Y' });
    });
    if (!imgs.length) {
      (productData.MultimediaObjects || productData.Multimedia || []).forEach((m) => {
        const type = String(m.Type || '').toLowerCase();
        if (type.includes('jpeg') || type.includes('jpg') || type.includes('png') || type.includes('highres')) {
          const src = safeURL(m.URL || m.Url || '');
          if (src) imgs.push({ thumb: src, full: src, main: false });
        }
      });
    }
    if (!imgs.length) {
      setHTML('icecat-bilder', '<p class="icecat-loading">Keine Produktbilder verfügbar.</p>');
      return;
    }
    imgs.sort((a, b) => (a.main ? -1 : b.main ? 1 : 0));
    let html = `<p class="icecat-bilder-count">${imgs.length} Produktbild${imgs.length !== 1 ? 'er' : ''}</p>`;
    html += '<div class="icecat-gallery-grid">';
    imgs.forEach((img, index) => {
      html += `<img src="${escapeHTML(img.thumb)}" data-full="${escapeHTML(img.full)}" alt="Produktbild ${index + 1}" loading="lazy">`;
    });
    html += '</div>';
    setHTML('icecat-bilder', html);
  }

  function renderProduktinfo(productData) {
    let html = '';
    const desc = productData.GeneralInfo && productData.GeneralInfo.Description;
    if (desc && desc.LongDesc) html += `<div class="icecat-desc">${sanitizeMarkup(desc.LongDesc)}</div>`;
    else if (productData.GeneralInfo?.SummaryDescription?.LongSummaryDescription) {
      html += `<div class="icecat-desc">${sanitizeMarkup(productData.GeneralInfo.SummaryDescription.LongSummaryDescription)}</div>`;
    }

    const bullets = productData.GeneralInfo?.GeneratedBulletPoints || productData.GeneralInfo?.BulletPoints || [];
    if (bullets.length) {
      html += '<ul class="icecat-bullets">';
      bullets.forEach((b) => {
        html += `<li>${escapeHTML(b.Value || b)}</li>`;
      });
      html += '</ul>';
    }

    if (productData.ReasonsToBuy?.length) {
      html += '<div class="icecat-rtb">';
      productData.ReasonsToBuy.forEach((reason) => {
        html += '<div class="icecat-rtb-item">';
        const img = safeURL(reason.HighPic || '');
        if (img) html += `<img src="${escapeHTML(img)}" alt="" loading="lazy">`;
        if (reason.Title) html += `<strong>${escapeHTML(reason.Title)}</strong>`;
        if (reason.Value) html += `<p>${escapeHTML(reason.Value)}</p>`;
        html += '</div>';
      });
      html += '</div>';
    }
    setHTML('icecat-produktinfo', html || '<p class="icecat-loading">Keine Produktinformationen verfügbar.</p>');
  }

  function featName(feature) {
    let name = '';
    if (feature.CategoryFeature?.Feature?.Name) name = feature.CategoryFeature.Feature.Name.Value || feature.CategoryFeature.Feature.Name || '';
    if (!name && feature.Feature?.Name) name = feature.Feature.Name.Value || feature.Feature.Name || '';
    if (!name && feature.FeatureName) name = feature.FeatureName.Value || feature.FeatureName || '';
    if (!name && feature.Name) name = feature.Name.Value || feature.Name || '';
    return String(name);
  }

  function featVal(feature) {
    let value = feature.Presentation_Value || feature.PresentationValue || '';
    if (!value && feature.LocalValue) value = feature.LocalValue.Value || feature.LocalValue || '';
    if (!value) value = feature.Value || '';
    if (!value) value = feature.RawValue || '';
    return String(value);
  }

  function featSign(feature) {
    let measure = feature.CategoryFeature?.Feature?.Measure;
    if (measure) return measure.Sign || '';
    measure = feature.Feature?.Measure;
    if (measure) return measure.Sign || '';
    return '';
  }

  function grpFeatures(group) {
    return group.Features || group.FeatureGroup?.Features || [];
  }

  function renderTechSpecs(productData) {
    if (!productData.FeaturesGroups?.length) {
      setHTML('icecat-tech-specs', '<p class="icecat-loading">Keine Spezifikationen verfügbar.</p>');
      return;
    }
    let html = '';
    productData.FeaturesGroups.forEach((group) => {
      const features = grpFeatures(group);
      if (!features.length) return;
      const groupName = group.FeatureGroup?.Name?.Value || '';
      let rows = '';
      features.forEach((feature) => {
        const name = featName(feature);
        const value = featVal(feature);
        const sign = featSign(feature);
        if (name && value) rows += `<tr><td class="icecat-specs-label">${escapeHTML(name)}</td><td class="icecat-specs-value">${escapeHTML(value)}${sign ? ` ${escapeHTML(sign)}` : ''}</td></tr>`;
      });
      if (rows) {
        if (groupName) html += `<h3 class="icecat-specs-group">${escapeHTML(groupName)}</h3>`;
        html += `<table class="icecat-specs-table"><tbody>${rows}</tbody></table>`;
      }
    });
    setHTML('icecat-tech-specs', html || '<p class="icecat-loading">Keine Spezifikationen verfügbar.</p>');
  }

  function renderDownloads(productData) {
    const objects = productData.MultimediaObjects || productData.Multimedia || [];
    let items = '';
    objects.forEach((m) => {
      const url = safeURL(m.URL || m.Url || '');
      if (!url) return;
      const type = String(m.Type || m.ContentType || '').toLowerCase();
      if (type.includes('pdf') || type.includes('manual') || type.includes('leaflet') || type.includes('safety') || type.includes('fiche') || type.includes('document') || type.includes('guide') || type.includes('sheet')) {
        const label = m.Description || m.Type || 'Download';
        items += `<li><a href="${escapeHTML(url)}" target="_blank" rel="noopener">📄 ${escapeHTML(label)}</a></li>`;
      }
    });
    setHTML('icecat-downloads', items ? `<ul class="icecat-downloads-list">${items}</ul>` : '<p class="icecat-loading">Keine Downloads verfügbar.</p>');
  }

  function renderNachhaltigkeit(productData) {
    let html = '';
    const keywords = ['nachhaltig', 'recycl', 'energie', 'umwelt', 'co2', 'emission', 'sustain', 'energy', 'green', 'reparier', 'repairability'];
    (productData.MultimediaObjects || productData.Multimedia || []).forEach((m) => {
      const type = String(m.Type || '').toLowerCase();
      if (type.includes('energy label')) {
        const src = safeURL(m.ConvertedURL || m.URL || '');
        if (src) html += `<div class="icecat-energy-label"><img src="${escapeHTML(src)}" alt="EU Energy Label" style="max-height:220px;"></div>`;
      }
    });
    if (productData.FeaturesGroups) {
      productData.FeaturesGroups.forEach((group) => {
        const groupName = String(group.FeatureGroup?.Name?.Value || '').toLowerCase();
        if (!keywords.some((keyword) => groupName.includes(keyword))) return;
        let rows = '';
        grpFeatures(group).forEach((feature) => {
          const name = featName(feature);
          const value = featVal(feature);
          if (name && value) rows += `<tr><td class="icecat-specs-label">${escapeHTML(name)}</td><td class="icecat-specs-value">${escapeHTML(value)}</td></tr>`;
        });
        if (rows) {
          html += `<h3 class="icecat-specs-group">${escapeHTML(group.FeatureGroup?.Name?.Value || groupName)}</h3>`;
          html += `<table class="icecat-specs-table"><tbody>${rows}</tbody></table>`;
        }
      });
    }
    setHTML('icecat-nachhaltigkeit', html || '<p>Keine Nachhaltigkeitsdaten für dieses Produkt verfügbar.</p>');
  }

  function showLoading() {
    slots.forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.innerHTML = '<p class="icecat-loading">Produktdaten werden geladen…</p>';
    });
  }

  function fallbackToLoadbee() {
    const gtin = String(config.ean || '');
    const apiKey = String(config.loadbeeApiKey || '');
    if (!gtin || !apiKey) return;
    setHTML('icecat-produktinfo', `<div class="loadbeeTabContent" data-loadbee-apikey="${escapeHTML(apiKey)}" data-loadbee-gtin="${escapeHTML(gtin)}" data-loadbee-locale="de_DE"></div>`);
    setHTML('icecat-tech-specs', '<p class="icecat-loading">Keine Spezifikationen verfügbar.</p>');
    setHTML('icecat-downloads', '<p class="icecat-loading">Keine Downloads verfügbar.</p>');
    setHTML('icecat-nachhaltigkeit', '<p class="icecat-loading">Keine Nachhaltigkeitsdaten verfügbar.</p>');
    appendScript('https://cdn.loadbee.com/js/loadbee_integration.js');
  }

  function fallbackToFlix() {
    const distributor = String(config.flixDistributor || '');
    if (!distributor) {
      fallbackToLoadbee();
      return;
    }
    setHTML('icecat-produktinfo', '<div id="flix-inpage"></div>');
    setHTML('icecat-tech-specs', '<p class="icecat-loading">Keine Spezifikationen verfügbar.</p>');
    setHTML('icecat-downloads', '<p class="icecat-loading">Keine Downloads verfügbar.</p>');
    setHTML('icecat-nachhaltigkeit', '<p class="icecat-loading">Keine Nachhaltigkeitsdaten verfügbar.</p>');
    appendScript('https://media.flixfacts.com/js/loader.js', {
      type: 'text/javascript',
      'data-flix-distributor': distributor,
      'data-flix-language': 'de',
      'data-flix-brand': config.vendor || '',
      'data-flix-mpn': config.sku || '',
      'data-flix-ean': config.ean || '',
      'data-flix-inpage': 'flix-inpage',
      'data-flix-fallback-language': 'en',
    });
    window.setTimeout(() => {
      const el = document.getElementById('flix-inpage');
      if (el && el.children.length === 0 && el.innerHTML.trim() === '') fallbackToLoadbee();
    }, 5000);
  }

  function fallbackToOneworldsync() {
    const skey = String(config.oneWorldSyncKey || '');
    const zoneId = String(config.oneWorldSyncZone || '');
    if (!skey || !zoneId) {
      fallbackToFlix();
      return;
    }
    setHTML('icecat-produktinfo', '<div id="ccs-inline-content"></div><div id="ccs-feature-icons"></div>');
    setHTML('icecat-tech-specs', '<div id="ccs-explore-product"></div>');
    setHTML('icecat-downloads', '<div id="ccs-downloads"></div>');
    setHTML('icecat-nachhaltigkeit', '<div id="ccs-logos"></div>');
    const args = (window.ccs_cc_args = window.ccs_cc_args || []);
    args.push(['mf', config.vendor || '']);
    if (config.sku && config.sku !== config.ean) args.push(['pn', config.sku]);
    args.push(['lang', 'de']);
    args.push(['market', 'DE']);
    if (config.ean) args.push(['upcean', config.ean]);
    args.push(['_SKey', skey]);
    args.push(['_ZoneId', zoneId]);
    appendScript('https://cdn.cs.1worldsync.com/jsc/h1ws.js', { type: 'text/javascript' });
    window.setTimeout(() => {
      const el = document.getElementById('ccs-inline-content');
      const text = (el && (el.textContent || el.innerText) || '').trim();
      const hasMedia = el && el.querySelector('img,video,iframe,svg') !== null;
      if (!text || (text.length < 5 && !hasMedia)) fallbackToFlix();
    }, 5000);
  }

  function extractProductData(resp) {
    if (resp?.data?.GeneralInfo) return resp.data;
    if (resp?.data?.product?.GeneralInfo) return resp.data.product;
    if (resp?.GeneralInfo) return resp;
    if (resp?.product?.GeneralInfo) return resp.product;
    return null;
  }

  function loadExternalData() {
    if (state.loaded || state.loading) return;
    const url = apiUrl();
    if (!url) {
      fallbackToOneworldsync();
      return;
    }
    state.loading = true;
    showLoading();
    fetch(url)
      .then((response) => response.json())
      .then((resp) => {
        const productData = extractProductData(resp);
        if (!productData) {
          fallbackToOneworldsync();
          return;
        }
        renderProduktinfo(productData);
        renderTechSpecs(productData);
        renderDownloads(productData);
        renderNachhaltigkeit(productData);
        renderBilder(productData);
        const productInfo = document.getElementById('icecat-produktinfo');
        const productInfoText = (productInfo && (productInfo.textContent || productInfo.innerText) || '').trim();
        if (!productInfoText || productInfoText.length < 5) fallbackToOneworldsync();
      })
      .catch(() => fallbackToOneworldsync())
      .finally(() => {
        state.loaded = true;
        state.loading = false;
      });
  }

  function shouldLoadNow() {
    const activePanel = document.querySelector('.pdp-tabs__panel.is-active, .product-tab-panel.is-active');
    return !!activePanel?.querySelector('.icecat-tab-content');
  }

  document.addEventListener('click', (event) => {
    const image = event.target.closest('.icecat-gallery-grid img[data-full]');
    if (image) {
      openLightbox(image.getAttribute('data-full') || image.src);
      return;
    }

    const tabButton = event.target.closest('.product-tab-btn, .pdp-tabs__btn');
    if (!tabButton) return;
    window.setTimeout(() => {
      if (shouldLoadNow()) loadExternalData();
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (shouldLoadNow()) loadExternalData();
    });
  } else if (shouldLoadNow()) {
    loadExternalData();
  }
})();
